export const getInitalUrl = (
  modules: string[],
  clientCode: string,
  currentModule: string,
) => {
  const moduleCode = modules.includes(currentModule)
    ? currentModule
    : modules.filter((code) => code !== "client")[0];
  if (!moduleCode) return "/no-products";
  return `/${clientCode}/${moduleCode}`;
};
